import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[automate-task]'
})
export class TaskDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}



// WEBPACK FOOTER //
// ./client/app/automate/task.directive.ts